/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

const styles = {
  grid: (theme: Theme) => css`
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 2rem;
    margin: ${theme.spacing(24, 0, 48)};
  `,
};

interface Props {
  deadlineItems: JSX.Element[];
}

const DeadlineModule = ({ deadlineItems }: Props) => (
  <div>
    {deadlineItems && (
      <Grid container css={styles.grid}>
        {deadlineItems}
      </Grid>
    )}
  </div>
);

export default DeadlineModule;
